import { HttpClient} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// Import the AuthService type from the SDK
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.css']
})
export class AuthLoginComponent implements OnInit {
  rolesList: any = ['lb4b-employee','lb4b-super-employee'];
  workingEnvList: any = ['prod','dev'];
  profileJson: any;
  selectedRole: any;
  selectedEnv: any;
  role_msg;
  token_status;
  isDisplay: boolean = true;
  isCopyText: boolean = false;
  isWorkingEnv: boolean = false;
  isLogin: boolean = false;
  tokenRole;
  token_info;
  acc_token_info;
  env_msg;
  realm;
  key_realm;
  key_token;
  key_lb4b_token;
  paramsObject;
  paramsInfo;
  shScriptRole;
  scriptOperationMessage: any;
  visible: boolean = false;
  inVisible: boolean = true;
  isParams: boolean = false;
  isScriptTag: boolean = false;
  isTokenPage: boolean = true;
  isScriptInput: boolean = false;
  showMessage: boolean = false;

  constructor(
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private apiService:ApiService
  ) {}

  ngOnInit(): void {
    this.auth.idTokenClaims$.subscribe((claims) => {

      console.log("idTokenClaims:", claims);
    })
    this.auth.error$.subscribe((error) => {
      console.log("Error",error);
      setTimeout(() => {
         this.auth.logout();
      }, 1500);
    });

    this.auth.user$.subscribe((profile) => {
      this.profileJson = profile;
      console.log("profile", profile)
      if (profile) {
        if (JSON.parse(localStorage.getItem('isLoggedin'))) {
          const token = JSON.parse(localStorage.getItem('token'));
          if (token.exp && token.exp > Date.now()) {
            this.updateToken(token)
          }
          else {
            this.RefreshToken()
          }
        } else {
          this.claimData()
          this.isScriptTag = true
          this.isCopyText = true
        }

      } else {
          setTimeout(() => {
            this.auth.loginWithRedirect()
          }, 2000);
      }
    });


  }

  claimData() {
    this.auth.idTokenClaims$.subscribe((claims) => {
      let payload: any = {};
      payload.iv = claims['iv'];
      payload.secret_data = claims['secret_data'];
      payload.secret_key = claims['secret_key'];
      payload.given_role = this.route.snapshot.queryParamMap.get('role') || 'lb4b-employee';
      this.apiService.getAccessToken(payload).subscribe((response) => {
        console.log("getAccessToken response:", response);
        this.updateToken(response);
        this.isLogin = true;
        const params = {
          realmname: this.realm,
          access_token: response.access_token,
          exp: Date.now() + 800 * 1000,
        }
        localStorage.setItem('token', JSON.stringify(params))
        localStorage.setItem("isLoggedin", 'true')

      },
        (error) => {
          console.log("complete error message:", error);
        });
    })
  }
  form1 = new FormGroup({
    roles: new FormControl('', Validators.required)
  });

  get f1() {
    return this.form1.controls;
  }

  submit1() {
    this.selectedRole = this.form1.value;
    this.isDisplay = false;
    this.isWorkingEnv = true;
    this.showMessage = true;
    // let default_role = 'previously selected role'
    this.role_msg = "selected role is " + "'" + this.selectedRole.roles + "'";
  }

  // getting envs

  form2 = new FormGroup({
    workingEnv: new FormControl('', Validators.required)
  });

  get f2() {
    return this.form2.controls;
  }

  submit2() {
    this.selectedEnv = this.form2.value;
    this.isDisplay = false;
    this.isWorkingEnv = false;
    this.showMessage = true;
    // let default_role = 'previously selected role'
    this.env_msg =
      'selected env is ' +
      "'" +
      this.selectedEnv.workingEnv +
      "'" +
      ', please click login';
    this.isLogin = true;
  }

  // auth0 login
  loginWithRedirect(): void {
    // console.log('in auth0 login');
    if (
      this.paramsObject.params &&
      this.paramsObject.params.role != undefined &&
      this.paramsObject.params.env != undefined
    ) {
      console.log('inside login from queryparams');
      this.auth.loginWithRedirect({
        role: this.paramsObject.role,
        env: this.paramsObject.env,
      });
    } else {
      console.log('inside login from form selection');
      this.auth.loginWithRedirect({
        role: this.selectedRole.roles,
        env: this.selectedEnv.workingEnv,
      });
    }
    // old login method
    // this.auth.loginWithRedirect({ role: this.selectedRole.roles, env: this.selectedEnv.workingEnv });
  }

  // auth0 logout
  logout(): void {
    console.log('logged out!!!');
    localStorage.removeItem('isLoggedin');
    localStorage.removeItem('token');
    this.isLogin = true
    this.auth.logout({ returnTo: window.location.origin });
    this.apiService.logout().subscribe((response) => {
      console.log("logout response:", response);
      alert('You are logged out successfully, you can login again');
      window.location.reload();
    },
    (error) => {
      console.log("complete error message:", error);
      alert('You are logged out successfully with Error, you can login again');
      window.location.reload();
    }
    );
  }

  updateScript() {
    this.isTokenPage = false;
    // console.log('inside update script:', this.shScriptRole);
    this.isScriptTag = false;
    this.router.navigate(['/script-tags'], {
      queryParams: { param1: this.realm, param2: this.token_info },
    });
  }
  goToComponentHistory() {
    this.isTokenPage = false;
    this.isScriptTag = false;
    this.router.navigate(['/component-history'], {
      queryParams: { param1: this.realm, param2: this.token_info },
    });
  }
  RefreshToken() {
    this.apiService.refreshToken().subscribe((response) => {
      console.log("getScript response:", response);
      this.updateToken(response);
      const params = {
        realmname: this.realm,
        access_token: response.access_token,
        exp: Date.now() + 800 * 1000,
      }
      localStorage.setItem('token', JSON.stringify(params))
      alert('Your token is updated successfully, you can continue with your work');
    },
      (error) => {
        console.log("complete error message:", error);
        localStorage.removeItem('token');
        localStorage.removeItem('isLoggedin');
        window.location.reload();

      }
    );
  }
  updateToken(response) {
    console.log('inside update token:', response);
    this.key_token = 'authorization';
    this.key_realm = 'realmname';
    this.acc_token_info = 'Bearer ' + response.access_token;
    this.realm = 'acumen-realm'
    this.isScriptTag = true
    this.isCopyText = true
  }
}
